import { monthsInRange } from './dateRange.js'

const perJobTimeSavedHours = (p) => (p.manualTimeMinutes || 0) / 60
const perJobCostSaved = (p) => perJobTimeSavedHours(p) * (p.hourlyCost || 0)
const itemTotalTimeSavedHours = (p) => (p.transactions || 0) * perJobTimeSavedHours(p)
const itemTotalCostSaved = (p) => (p.transactions || 0) * perJobCostSaved(p)

const MIN_FTE_MONTHS = (7 / 365.25) * 12

export function calculateRoiStats(items, range, countLabel = 'Transactions') {
  const months = monthsInRange(range)
  const hoursRegained = items.reduce((sum, p) => sum + itemTotalTimeSavedHours(p), 0)
  const totalCostSaved = items.reduce((sum, p) => sum + itemTotalCostSaved(p), 0)
  const totalCount = items.reduce((sum, p) => sum + (p.transactions || 0), 0)

  const fteRegained = hoursRegained > 0 ? hoursRegained / (1700 / months) : 0
  const fteValue = months < MIN_FTE_MONTHS ? '—' : Number(fteRegained.toFixed(2))

  return [
    { label: 'Workforce capacity regained (FTE)', value: fteValue },
    { label: 'Workforce capacity regained (hours)', value: Number(hoursRegained.toFixed(2)) },
    { label: 'Workforce cost savings (DKK)', value: Number(totalCostSaved.toFixed(2)) },
    { label: countLabel, value: totalCount }
  ]
}
